module.exports = __webpack_public_path__ + "static/media/IMG-7.2e5e745c.jpg";